export { EventDetailLoadingSkeleton as default } from './[id]';